<template>
  <div>
    <my-header></my-header>

    <div class="content-container-level-1">
      <div class="h-panel">
        <b-button v-b-modal.help-modal>Help</b-button>

        <b-button
          :to="{name: 'new_update_offer'}"
          variant="primary"
        >
          New update offer
        </b-button>
      </div>

      <h2>Update Offers</h2>

      <p v-if="message !== null">
        {{message}}
      </p>

      <table v-if="update_offers !== null && update_offers.length > 0" class="table table-bordered text-nowrap">
        <thead class="thead-dark">
          <tr>
            <th scope="col" rowspan="2">Id</th>
            <th scope="col" rowspan="2">Title</th>
            <th scope="col" rowspan="2">Icon</th>
            <th scope="col" rowspan="2">Image</th>
            <th scope="col" rowspan="2">Start</th>
            <th scope="col" rowspan="2">Finish</th>
            <th scope="col" rowspan="2">Versions</th>
            <th scope="col" rowspan="2">Icon Place</th>
            <th scope="col" rowspan="2">Type</th>
            <th scope="col" rowspan="2">Platforms</th>
            <th scope="col" rowspan="2" v-if="mayManageUpdateOffers">Actions</th>
          </tr>
        </thead>
        <tr
          v-for="update_offer in update_offers"
          :key="update_offer.id"
          >
          <td>
            {{update_offer.id}}
          </td>
          <td>
            {{update_offer.title}}
          </td>
          <td>
            <img :src="HTTP_RESOURCES_ROOT + update_offer.icon_url" width="32" height="32"/>
          </td>
          <td>
            <a :href="HTTP_RESOURCES_ROOT + update_offer.image_url">image</a>
          </td>
          <td>
            {{update_offer.stime | getMomentStr}}
          </td>
          <td>
            {{update_offer.ftime | getMomentStr}}
          </td>
          <td>
            {{update_offer.client_min_version | convertVersionCodeToStr}} - {{update_offer.client_max_version | convertVersionCodeToStr}}
          </td>
          <td>
            {{update_offer.icon_place | getEnumIconPlaceName}}
          </td>
          <td>
            {{update_offer.type | getEnumUpdateOfferTypeName}}
          </td>
          <td>
            {{update_offer.platforms | getPlatforms}}
          </td>
          <td
            v-if="mayManageUpdateOffers"
          >
            <b-button
              @click="deleteUpdateOfferWithConfirmation(update_offer)"
              variant="danger"
              size="sm"
              class="ml-2"
            >
              Delete
            </b-button>
          </td>
        </tr>
      </table>

      <loading-indicator
        v-if="isLoading"
      />

    </div>

    <b-modal id="help-modal" title="Help" ok-only ok-title="Close">
      <div class="help">
        <p>
          All update offers are shown on this page.
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import auth from '../auth.js';
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';
import { HTTP_RESOURCES_ROOT } from '../autogen/settings.js';

import { confirmAction } from '../service/confirm.js';

import { arrayDeleteFirstItemByValue } from '../util.js';
import { isRoleAdmin                 } from '../util.js';
import { convertVersionCodeToStr     } from '../util.js';

import MyHeader from './Header.vue';
import LoadingIndicator from './LoadingIndicator.vue';

import { getEnumPlatformBitName    } from '../autogen/bundle.js';
import { getEnumPlatformBitValues  } from '../autogen/bundle.js';

import { getEnumIconPlaceName  } from '../autogen/bundle.js';

import { getEnumUpdateOfferTypeName  } from '../autogen/bundle.js';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'Update Offers',

  components: {
    MyHeader,
    LoadingIndicator
  },

  data() {
    return {
      actor: auth.getViewer(),

      loadState: LOAD_STATE_INIT,
      updateOfTypeNameMap: null,
      update_offers: null,

      HTTP_RESOURCES_ROOT: HTTP_RESOURCES_ROOT,

      timerId: null,
      nowSec: Date.now() / 1000,
    };
  },

  computed: {  
    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(this.isLoadedNormal && this.update_offers !== null && this.update_offers.length === 0) {
        return 'No update offers.';
      }
      return null;
    },

    /** @returns {boolean} */
    mayManageUpdateOffers() {
      return isRoleAdmin(this.actor.role);
    },

    /** @returns {boolean} */
    mayDeleteSeason() {
      return isRoleAdmin(this.actor.role);
    },
  },

  created() {
    this.timerId = setInterval(this.updateTime, 1000);

    this.loadUpdateOffers();
  },

  beforeDestroy() {
    if(this.timerId !== null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  },

  methods: {
    updateTime() {
      this.nowSec = Date.now() / 1000;
    },

    loadUpdateOffers() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = '/update_offers';
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        const update_offers = data.update_offers;
        update_offers.sort((a, b) => b.id - a.id);

        this.update_offers = update_offers;

        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(e => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(e.response.data, {sender: this});
      });
    },

    deleteUpdateOfferWithConfirmation(update_offer) {
      notifier.deleteSenderNotifications(this);

      this.confirmUpdateOfferDeletion(() => {
        this.deleteUpdateOffer(update_offer);
      });
    },

    // function onConfirmed()
    confirmUpdateOfferDeletion(onConfirmed) {
      confirmAction(
        this,
        'Are you sure you want to delete this update offer {env}?',
        'Delete',
        onConfirmed,
      );
    },

    deleteUpdateOffer(update_offer) {
      notifier.deleteSenderNotifications(this);

      const url = `/update_offer/${update_offer.id}/del`;
      HTTP.post(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        arrayDeleteFirstItemByValue(this.update_offers, update_offer);
        notifier.showSuccess('Update Offer deleted.');
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },

  filters: {
    getEnumIconPlaceName,
    getEnumUpdateOfferTypeName,
    getPlatforms(platforms) {
      let platforms_text = "";
      for(let i = 1; i < getEnumPlatformBitValues().length; ++i)
      {
        let value = getEnumPlatformBitValues()[i];
        if((platforms & value) === 0)
          continue;
        let text = getEnumPlatformBitName(value);
        platforms_text += text + " ";
      }
      return platforms_text;
    },
    convertVersionCodeToStr
  },
};
</script>

<style scoped>
  .season-type-name {
    font-weight: bold;
  }
</style>
